import {Component, OnInit, Input} from "@angular/core";
import {Http, Response} from "@angular/http";

export class PlcItem {
    active: boolean;
    name: string;
    value: string;

    constructor(name: string, value: string) {
        this.name = name;
        this.value = value;
    }
}

@Component({
    selector: 'home',
    templateUrl: 'app/components/home/home.component.html'
})
export class HomeComponent implements OnInit {

    constructor() {
    }

    public ngOnInit() {
    }

}
